var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "el-row",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "el-col",
            { staticStyle: { "font-weight": "bold" }, attrs: { span: 3 } },
            [
              _c("div", { staticStyle: { padding: "10px 0px" } }, [
                _vm._v("自动业主审核说明：")
              ])
            ]
          ),
          _c("el-col", { attrs: { span: 21 } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#cfcfcf",
                  padding: "10px 20px",
                  "font-weight": "bold",
                  width: "fit-content"
                }
              },
              [
                _vm._v(
                  " 当开启自动业主审核开关，小区居民提交的房屋绑定信息与平台信息相匹配，则自动审核通过，无需人工审核。 "
                )
              ]
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "el-col",
            { staticStyle: { "font-weight": "bold" }, attrs: { span: 3 } },
            [_vm._v(" 自动业主审核开关： ")]
          ),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-switch", {
                attrs: {
                  "active-color": "#13ce66",
                  "active-value": 1,
                  "inactive-value": 0,
                  "inactive-color": "#ff4949"
                },
                on: { change: _vm.changeAudit },
                model: {
                  value: _vm.data.isSwitchAudit,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "isSwitchAudit", $$v)
                  },
                  expression: "data.isSwitchAudit"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "el-col",
            { staticStyle: { "font-weight": "bold" }, attrs: { span: 3 } },
            [_vm._v(" 操作人员姓名： ")]
          ),
          _c("el-col", { attrs: { span: 21 } }, [
            _vm._v(" " + _vm._s(_vm.data.opName) + " ")
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "el-col",
            { staticStyle: { "font-weight": "bold" }, attrs: { span: 3 } },
            [_vm._v(" 最新操作时间： ")]
          ),
          _c("el-col", { attrs: { span: 21 } }, [
            _vm._v(" " + _vm._s(_vm.data.opDate) + " ")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }